import Layout from "../../components/Layout/Layout";

function Users(props) {
  return (
    <Layout {...props}>
      <h4>Users</h4>
    </Layout>
  );
}

export default Users;
